// extracted by mini-css-extract-plugin
export default {"textContainer":"Signup-styles__textContainer__r9v_2","title":"Signup-styles__title__L3dOZ","subTitle":"Signup-styles__subTitle__RAVEf"};